import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  code: string;
  locale: string;
}

const PriorityBadge: React.FC<Props> = ({ code, locale }) => (
  <div className="badge-base">
    <div className="badge-icon">
      <FontAwesomeIcon icon="circle" className={`priority-svg priority-${code}`} />
    </div>
    <div className="badge-text">
      <span>{locale || code}</span>
    </div>
  </div>
);

export default React.memo(PriorityBadge);
